module.exports = __webpack_public_path__ + "img/search.227a46e4.svg";